<div class="progress-circle" [title]="progress + '%'">
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="10"
      cy="10.8"
      r="9"
      fill="none"
      stroke="#E5E7EB"
      stroke-width="2"
    />
    <circle
      cx="10"
      cy="10.8"
      r="9"
      fill="none"
      stroke="#2DBBFC"
      stroke-width="2"
      [style.strokeDasharray]="circumference"
      [style.strokeDashoffset]="dashOffset"
    />
  </svg>
</div>
